import { IAction } from '@framework/state/createAction';
import { ITraceFilterResponse } from '@/condor/domain/vo/types';
import { TTraceFiltersPayload } from '@/creditflowresearch/domain/vo/Trace/IMarketTradesPayload';
import actionTypes from './actionTypes';

export interface ITraceFiltersState {
  isFetching: boolean,
  items: Partial<ITraceFilterResponse>,
  initialFilters: object,
  appliedFilters: object,
  filtersPayload: TTraceFiltersPayload | null,
  dateFromMin: number | null,
  dateToMax: number | null,
}

export const initialState: ITraceFiltersState = {
  isFetching: false,
  items: {},
  initialFilters: {},
  appliedFilters: {},
  filtersPayload: null,
  dateFromMin: null,
  dateToMax: null,
};

export default function reducer(state: ITraceFiltersState, action: IAction): ITraceFiltersState {
  switch (action.type) {
    case actionTypes.GET_TRACE_FILTER:
      return {
        ...state,
        isFetching: true,
      };
    case actionTypes.GET_TRACE_FILTER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: action.payload,
      };
    case actionTypes.GET_TRACE_FILTER_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case actionTypes.TRACE_FILTER_PAYLOAD:
      return {
        ...state,
        filtersPayload: action.payload,
      };
    case actionTypes.TRACE_FILTER_APPLY:
      return {
        ...state,
        appliedFilters: action.payload,
      };
    case actionTypes.TRACE_INITIAL_FILTERS:
      return {
        ...state,
        initialFilters: action.payload,
      };
    case actionTypes.TRACE_FILTER_MIN_DATE_FROM:
      return {
        ...state,
        dateFromMin: action.payload,
      };
    case actionTypes.TRACE_FILTER_MAX_DATE_TO:
      return {
        ...state,
        dateToMax: action.payload,
      };
    default:
      return state;
  }
}
